'use client';

import type { ReactNode } from 'react';
import { HStack } from '@terra/ui-styled-system';
import { Alert01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { Badge } from '../../../../../components/badge';
import { Tooltip } from '../../../../../components/tooltip';

export function HitlElevatedBadge() {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );

  return (
    <Tooltip title={t('elevatedBadgeTooltip')} maxW="320px">
      <Badge
        variant="outline"
        size="xs"
        icon={<Alert01Icon size={12} />}
        color="fg.vulnerability.vulnerable"
        borderColor="border.vulnerability.critical"
      >
        {t('elevatedBadge')}
      </Badge>
    </Tooltip>
  );
}

export function withElevatedBadge({
  elevated,
  actions,
}: {
  elevated: boolean | undefined;
  actions: ReactNode;
}): ReactNode {
  if (!elevated) {
    return actions;
  }

  return (
    <HStack gap={1} alignItems="center">
      <HitlElevatedBadge />
      {actions}
    </HStack>
  );
}
